import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// NOTE: You could add the actual Privacy Policy here as a fallback
//       instead of showing this error message.
const fallbackPrivacyPolicy = `
Your privacy is important to us. It is Local Hire Marketplace's policy to respect your privacy regarding any information we may collect from you across our website and services.

## 1. Information We Collect
We collect information you provide directly to us when creating an account, listing equipment, or contacting support. This may include your name, email address, phone number, and location details.

## 2. How We Use Information
We use the information we collect to operate, maintain, and improve our services, facilitate bookings between users, communicate with you, and ensure platform security.

## 3. Sharing of Information
We do not share your personal information with third parties except as necessary to complete your booking transactions, comply with legal obligations, or protect platform safety.

## 4. Contact Us
If you have any questions about this Privacy Policy, please contact marketplace support.
`;

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'privacy',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Privacy Policy' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackPrivacyPolicy,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Privacy policy page',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Privacy policy fetch failed',
    },
  },
};

// This is the fallback page, in case there's no Privacy Policy asset defined in Console.
const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
